import { Component,  Input, OnDestroy } from '@angular/core';
import { App } from 'ionic-angular';
import { BusquedaTesoroNivelesPage, TabsPage } from '@pages';
import * as moment from 'moment';

@Component({
  selector: 'busqueda-tesoro-card',
  templateUrl: 'busqueda-tesoro-card.html'
})
export class BusquedaTesoroCardComponent implements OnDestroy {

  @Input() backIcon: boolean;

  _busquedaTesoro: any;
  @Input() set busquedaTesoro(value: any) {
    if(value) {
      this._busquedaTesoro = value;
      this.formatoFecha();
    }
  }

  _setTimeout: any;

  equipoJugador: any;

  counterBack: any;

  constructor(
    private app: App
  ) {  }

  ngOnDestroy(): void {
    if(this._setTimeout) {
      clearTimeout(this._setTimeout);
    }
  }

  goToInstructions() {
    if(!this.backIcon) {
      this.app.getRootNavs()[0].setRoot(BusquedaTesoroNivelesPage,{
        busquedaTesoro: this._busquedaTesoro
      });
    }
  }

  goToTab() {
    this.app.getRootNavs()[0].setRoot(TabsPage, { active: 1 });
  }

  formatoFecha() {
    // if(!this._busquedaTesoro) return;

    let fechaInicio = moment();
    let fechaFin = moment(`${this._busquedaTesoro.fechaFin} 23:59:59`);

    let segundos = fechaFin.diff(fechaInicio, 'seconds');

    const d = Math.floor(segundos / (3600*24));
    const h = Math.floor(segundos % (3600*24) / 3600);
    const m = Math.floor(segundos % 3600 / 60);
    const s = Math.floor(segundos % 60);

    this.counterBack = {
      dias: d,
      horas: h,
      minutos: m,
      segundos: s,
    }
    this._setTimeout = setTimeout( () => this.formatoFecha(), 1000);
  }
}



// WEBPACK FOOTER //
// ./src/components/busqueda-tesoro-card/busqueda-tesoro-card.ts